import React, { useState, useEffect } from "react";
import styles from "./ProfileCard.module.css";
import { Link } from "react-router-dom";
import TagsList from "./More";
import { getCountryMap } from "../../utils/countryCache";
import {
  buildIdNameMap,
  extractSelectedIds,
} from "../AccordionCategory/accordionTree.helpers";

export default function ProfileCard(props) {
  const {
    photograph,
    fullName,
    profileSummary,
    subjectMatterExpertise,
    mentorshipOffered,
    country,
    currentDesignation,
    departmentFacultyName,
    institutionName,
    imparcId
  } = props.profileData;

  const {
    user,
    role,
    subjectExpertiseList = [],
    mentorshipOfferedList = [],
  } = props;

  const [countryName, setCountryName] = useState(country);
  useEffect(() => {
    let mounted = true;

    getCountryMap().then((map) => {
      if (mounted && map[country]) {
        setCountryName(map[country]);
      }
    });

    return () => {
      mounted = false;
    };
  }, [country]);

  const subjectTags = React.useMemo(() => {
    if (!subjectMatterExpertise || !subjectExpertiseList.length) return [];

    const idNameMap = buildIdNameMap(subjectExpertiseList);
    const selectedIds = extractSelectedIds(subjectMatterExpertise);

    return selectedIds.map((id) => idNameMap[id]).filter(Boolean);
  }, [subjectMatterExpertise, subjectExpertiseList]);

  const mentorshipTags = React.useMemo(() => {
    if (!mentorshipOffered || !mentorshipOfferedList.length) return [];

    const idNameMap = buildIdNameMap(mentorshipOfferedList);
    const selectedIds = extractSelectedIds(mentorshipOffered);

    return selectedIds.map((id) => idNameMap[id]).filter(Boolean);
  }, [mentorshipOffered, mentorshipOfferedList]);

  return (
    <div className={styles.card}>
      {/* Left Side - Image */}
      <div className={styles.left}>
        <div className={styles.imageWrapper}>
          <img
            src={photograph}
            alt={fullName}
            className={styles.profileImage}
          />
        </div>
        <Link
          className={styles.viewProfile}
          to={`/${user}/${props.profileData.user_id}`}
        >
          View Profile
        </Link>
      </div>

      {/* Right Side - Content */}
      <div className={styles.right}>
        <div className={styles.headingOuter}>
          {" "}
          <div className={styles.leftHeading}>
            <div className={styles.header}>
              <h3>{fullName}</h3>
              {imparcId && <span className={styles.badge}>{imparcId}</span>}
            </div>
            <p className={styles.title}>
              {currentDesignation} | {departmentFacultyName} | {institutionName}
            </p>
          </div>
          {/* <div className={styles.rightHeading}>
            <button
              className={styles.cta}
              onClick={() => setAuthModal({ open: true, tab: "login" })}
            >
              Create Project
            </button>

            <div className={styles.meta}>
              <div className={styles.ratingContainer}>
                <div className={styles.rating}>
                  {Array.from({ length: rating }, (_, i) => (
                    <span key={i}>★</span>
                  ))}
                </div>
                <span className={styles.currency}> {currency}</span>{" "}
                <span className={styles.rate}> {rate}/hr</span>
              </div>
            </div>
          </div> */}
        </div>

        <div className={styles.location}>{countryName}</div>
        <p className={styles.description}>
          {profileSummary?.slice(0, 135) || ""}{" "}
          <Link to={`/${user}/${props.profileData.user_id}`}>Read More</Link>
        </p>

        {role === "mentor" && (
          <>
            <p className={styles.subjectHeading}>
              <span className={styles.blue}>Subject</span>{" "}
              <span className={styles.orange}>Matter Expertise</span>
            </p>

            {subjectTags.length > 0 ? (
              <TagsList
                tags={subjectTags}
                tagsSize={2}
                showMore={true}
                profileId={props.profileData.user_id}
              />
            ) : (
              <div className={styles.noData}>
              No Data Available.
              </div>
            )}

            <p className={styles.subjectHeading}>
              <span className={styles.blue}>Mentorship </span>{" "}
              <span className={styles.orange}>Offered</span>
            </p>
            {mentorshipTags.length ? (
              <TagsList
                tags={mentorshipTags}
                tagsSize={2}
                showMore={true}
                profileId={props.profileData.user_id}
              />
            ) : (
              <div className={styles.noData}>
              No Data Available.
              </div>
            )}
          </>
        )}
      </div>
      <div className={styles.fullProfile}>
        <Link
          className={styles.viewProfile}
          to={`/${user}/${props.profileData.user_id}`}
        >
          VIEW FULL PROFILE &gt;
        </Link>
      </div>
    </div>
  );
}
